if (!customElements.get('treatment-state-select')) {
  customElements.define('treatment-state-select', class TreatmentStateSelect extends CustomSelect {

    init ()
    {
      super.init();

      this.wrapper = this.closest('.treatment-state-wrapper');

      this.addEventListener('change', e => {
        if (window.app && window.app.treatmentCountry) {
          window.app.treatmentCountry.setState(this.selectElement.value);
        }
      });

      // Visibility follows the treatment country: only shown for Australia.
      ['treatment_country', 'treatment_country_change', 'treatment_country_updated'].forEach(event => {
        onBroadcast(event, () => this.sync());
      });

      // Keep the displayed value in sync if the state is changed elsewhere.
      onBroadcast('treatment_au_state_change', data => {
        if (data && data.code) {
          this.selectValue(data.code);
        }
      });

      this.sync();
    }

    sync ()
    {
      // Resolve via the single source of truth — safe before app.init().
      const selection = window.app && window.app.treatmentCountry
        ? window.app.treatmentCountry.getSelection()
        : { country: null, state: null };

      if (!this.wrapper) {
        return;
      }

      if (selection.country === 'AU') {
        this.wrapper.removeAttribute('hidden');

        if (selection.state) {
          this.selectValue(selection.state);
        }
      } else {
        this.wrapper.setAttribute('hidden', '');
      }
    }

    selectValue (value)
    {
      if (!value) {
        return;
      }

      const option = this.selectElement.querySelector(`option[value="${value}"]`);

      if (!option) {
        return;
      }

      // Set the underlying value and let CustomSelect.update() read
      // selectedIndex. We intentionally do NOT set this.optionIndex — a stale
      // value there would make update() keep showing the wrong option.
      this.selectElement.value = value;
      this.update();
    }
  });
}
